<template lang="html">
  <div class="">
     <div class="col-md-12 col-sm-12 Dashboard">
        <div class="level jc-sb ai-c fd-res m-tac">
            <div v-if="activeClient.name === ''">
                <h6 class="mb-0-5 c-mg tt-up ls-1">Found S+M</h6>
                <h2 class="mt-0">Client Pacing</h2>
            </div>
            <div v-else>
                <a :href="`/admin#/clients/${activeClient.slug}`">
                    <h6 class="mb-0-5 c-mg tt-up ls-1">{{ activeClient.name }}</h6>
                </a>
                <h2 class="mt-0">{{ currentMonthName }} Pacing</h2>
            </div>
        </div>
        <hr class="mt-0-5 brdc">
        <client-pacing-details v-show="showClientDetails"></client-pacing-details>
        <div v-show="!showClientDetails">
            <div v-if="clients.length === 0 && loadingClients === false">
                <div class="panel panel-default">
                  <div class="panel-body">
                      <div class="panel-title">
                          You currently have no assigned clients. To assign yourself to a client:
                      </div>
                      <br>
                      <blockquote>
                          <ol>
                              <li>Open the <a href="/admin#/clients" target="_blank">Client list</a>.</li>
                              <li>Select a <strong>Client</strong>.</li>
                              <li>Under the <strong>Assigned Team Members </strong> section, click <strong>Manage Team Members</strong>.</li>
                              <li>Click the <strong>+</strong> icon next to your user.</li>
                          </ol>
                      </blockquote>

                  </div>
                </div>
            </div>
            <top-progress ref="topProgress" :color="'#95d243'"></top-progress>
            <template v-if="!loadingClients" v-for="client in clients">
                <div class="panel panel-default client-pacing-panel" >
                  <div class="panel-body" :class="pacingClass(client.spend,client.budget)">
                      <div class="panel-title" >
                           <a class="btn-block" @click="showClientPacingDetails(client)">{{ client.client_name }}</a>
                       </div>
                      <!-- <div style="overflow-x:auto;"> -->
                          <table class="table client-pacing has-mobile-cards">
                              <thead>
                                  <tr>
                                      <th>Spend</th>
                                      <th>Budget</th>
                                      <th>Pacing</th>
                                      <th>Projected</th>
                                      <th>Leftover</th>
                                      <!-- <th>Leftover Per Day</th> -->
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <td data-label="Spend">
                                          {{ client.spend | currency }}
                                      </td>
                                      <td data-label="Budget">
                                          {{ client.budget | currency }}
                                      </td>
                                      <td data-label="Pacing">
                                          {{ getCurrentPacing(client.spend,client.budget) }}
                                      </td>
                                      <td data-label="Projected">
                                          {{ getCurrentProjection(client.spend,client.exclude_weekends) | currency }}
                                      </td>
                                      <td  data-label="Leftover">
                                          {{ getLeftover(client.spend,client.budget,client.exclude_weekends) | currency }}
                                      </td>
                                      <!-- <td>
                                          {{ getLeftOverPerDay(client.budget, client.spend, client.exclude_weekends) | currency }}
                                      </td> -->
                                  </tr>
                              </tbody>
                          </table>
                      <!-- </div> -->
                  </div>
                </div>
            </template>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import topProgress from 'vue-top-progress'
import ClientPacingDetails from './ClientPacingDetails.vue'

var datesAndPacing = require('./mixins/datesAndPacing');

export default {
    mixins: [datesAndPacing],

    components: {
        ClientPacingDetails,
        topProgress
    },

    props: ['user', 'currentTeam'],

    data() {
        return {
            loadingClients: true,
            currentMonthName: moment().subtract(1, 'days').format('MMMM')
        }
    },

    computed: {
        ...mapGetters('pacing', {
            'clients': 'clients',
            'isAdmin': 'isAdmin',
            'showClientDetails': 'showClientDetails',
            'activeClient': 'activeClient',
        }),
    },

    created() {
        let self = this;

        Bus.$on('sparkHashChanged', function(hash, parameters) {
            if (hash != 'client-pacing') {
                return true;
            }

            if (parameters && parameters.length === 1) {
                history.pushState(null, null, '#/client-pacing/' + parameters[0]);
                self.$store.dispatch('pacing/showClientDetails');
                self.loadClientPacingDetails({
                    slug: parameters[0]
                });
            } else {
                self.reloadClientList();
            }

            return true;
        });
    },

    mounted() {
        this.prepareComponent();
    },

    methods: {
        prepareComponent() {
            this.setDateHelpers();
            this.setPermissions();
            this.setCurrentTeam();
        },

        getClientList() {
            this.loadingClients = true;
            this.$refs.topProgress.start();
            this.$store.dispatch('pacing/getAssignedClients')
                .then((response) => {
                    this.$refs.topProgress.done();
                    this.loadingClients = false;
                })
                .catch((error) => {})
        },

        reloadClientList() {
            this.$store.dispatch('pacing/hideClientDetails');
            this.getClientList()
        },

        setCurrentTeam() {
            this.$store.dispatch('pacing/setCurrentTeam', {
                team: this.currentTeam
            });
        },

        setPermissions() {
            this.$store.dispatch('pacing/setAuth', {
                auth: this.user.teams[0].pivot
            });
        },

        showClientPacingDetails(client) {
            history.pushState(null, null, '#/client-pacing/' + client.slug);
            this.$store.dispatch('pacing/showClientDetails');
            this.loadClientPacingDetails(client);
        },

        loadClientPacingDetails(client) {
            Bus.$emit('load-client-details', client.slug);
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/pacing/ClientPacing.vue